<template>
  <div>
    <b-card-code>
      <b-card>
        <div class="d-flex justify-content-between flex-wrap">
          <!-- sorting  -->
          <b-form-group
            label="Sort"
            label-size="sm"
            label-align-sm="left"
            label-cols-sm="3"
            label-for="sortBySelect"
            class="ml-1"
          >
            <b-input-group size="sm">
              <b-form-select
                id="sortBySelect"
                v-model="sortBy"
                :options="sortOptions"
              >
                <template #first>
                  <option value="">
                    none
                  </option>
                </template>
              </b-form-select>
              <b-form-select
                v-model="sortDesc"
                size="sm"
                :disabled="!sortBy"
              >
                <option :value="false">
                  Asc
                </option>
                <option :value="true">
                  Desc
                </option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
          <b-form-group
            label="Per Page"
            label-cols="6"
            label-align="left"
            label-size="sm"
            label-for="sortBySelect"
            class="text-nowrap mb-md-0 mr-1"
          >
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              inline
              :options="pageOptions"
            />
          </b-form-group>
          <!-- filter -->
          <b-form-group
            label="Filter"
            label-cols-sm="2"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="mr-1"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-button
                  :disabled="!filter"
                  @click="filter = ''"
                >
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <!-- Table -->
        <b-table
          striped
          hover
          responsive
          sticky-header
          :items="items"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :filter="filter"
          :filter-included-fields="filterOn"
          class="position-relative"
          @filtered="onFiltered"
        >
     <template #cell(action)="row">
              <span>
            <template slot:button-content>
               <b-form-checkbox switch></b-form-checkbox>
              <!-- <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" /> -->
            </template>
        </span>
     </template>

        </b-table>
         <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
              <p class="text-nowrap mb-md-0 mr-1 align-left" />
              <!-- page length -->
              <div>
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
                  style="align-content: right"
                >
                  <template #prev-text>
                    <feather-icon
                      icon="ChevronLeftIcon"
                      size="18"
                    />
                  </template>
                  <template #next-text>
                    <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                    />
                  </template>
                </b-pagination>
              </div>
            </b-card-body>
      </b-card>
    </b-card-code>

  </div>
</template>

<script>
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import {
  //   BCol,
  //   BOverlay,
  BCard,
  //   BRow,
  BTable,
  //   BImg,
  //   BBadge,
  //   BMediaBody,
  //   BAvatar,
  //   BCardText,
  //   BMediaAside,
  //   BMedia,
  BFormGroup,
      BFormCheckbox,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  //   BCardBody,
  //   BLink,
    BDropdown,
  //   BDropdownItem,
} from 'bootstrap-vue'

export default {
  components: {
    BCardCode,
  
    // XLSX,
    // vSelect,
    // BCol,
    // BOverlay,
    BCard,
    // BRow,
    BTable,
    BFormCheckbox,
    // BImg,
    // BBadge,
    // BMediaBody,
    // BAvatar,
    // BCardText,
    // BMediaAside,
    // BMedia,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    // BCardBody,
    // BLink,
    BDropdown,
    // BDropdownItem,
    // ToastificationContent,
  },
  data() {
    return {
      checked: false,
      items: [
        {
          id: 1,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 2,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 3,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 4,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 5,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 6,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 7,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 8,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 9,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
        {
          id: 10,
          area: 'Sparing',
          company: 'PT Chronos Universal',
        },
      ],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true,
        },
        { key: 'area' },
        { key: 'company' },
           { key: "action" }
      
      ],
    }
  },
}

</script>

<style></style>
